import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowLeftIcon } from 'lucide-react';
export function Architecture() {
  const projects = [{
    title: 'Aleksandro-Nevsky Manufacture',
    category: 'Commercial Architecture',
    description: 'Class-A business center project development within a business complex redevelopment programme',
    image: 'https://storage.yandexcloud.net/maria-images/images/ready_anm/2.jpg',
    color: 'from-emerald-100 to-teal-100',
    link: '/projects/aleksandro-nevsky'
  }, {
    title: 'Transformer Theatre',
    category: 'Interior Architecture, Adaptive Reuse',
    description: 'A renovation proposition for an abandoned Art Deco building in Bournemouth, reimagined as a flexible performance space',
    image: 'https://storage.yandexcloud.net/maria-images/images/aub_ready/Generated%20Image%20October%2026,%202025%20-%2011_26AM.png',
    color: 'from-stone-100 to-emerald-100',
    link: '/projects/transformer-theatre'
  }, {
    title: 'Mariinsky Theatre-3',
    category: 'Interior Planning, Adaptive Re-Use',
    description: "Transforming St. Petersburg's historic Main Post Office into a world-class concert venue",
    image: 'https://storage.yandexcloud.net/maria-images/images/mariinsky_ready/image%20(9).png',
    color: 'from-teal-100 to-cyan-100',
    link: '/projects/mariinsky-theatre'
  }, {
    title: 'Co-Living',
    category: 'Interior Architecture, Adaptive Re-Use',
    description: 'Residential communal living spaces for digital nomads and recent graduates',
    image: 'https://storage.yandexcloud.net/maria-images/images/co-living_ready/cafe%20basement%20view%203d.png',
    color: 'from-cyan-100 to-stone-100',
    link: '/projects/co-living'
  }];
  return <div className="w-full min-h-screen bg-stone-50" data-id="element-415">
      {/* Header */}
      <header className="py-8 px-6 bg-white border-b border-stone-200" data-id="element-416">
        <div className="max-w-7xl mx-auto flex items-center justify-between" data-id="element-417">
          <Link to="/" className="inline-flex items-center gap-2 text-stone-600 hover:text-stone-900 transition-colors" data-id="element-418">
            <ArrowLeftIcon className="w-5 h-5" data-id="element-419" />
            <span className="font-light" data-id="element-420">Back to Home</span>
          </Link>
          <h1 className="text-2xl font-light text-stone-900" data-id="element-421">Maria Elina</h1>
        </div>
      </header>
      {/* Hero Section */}
      <section className="py-20 px-6 bg-gradient-to-br from-stone-50 via-emerald-50/30 to-stone-50" data-id="element-422">
        <div className="max-w-7xl mx-auto text-center" data-id="element-423">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8
        }} data-id="element-424">
            <div className="text-6xl mb-6" data-id="element-425">🏛️</div>
            <h2 className="text-5xl md:text-7xl font-light text-stone-900 mb-6" data-id="element-426">
              Architecture
            </h2>
            <p className="text-xl text-stone-600 font-light max-w-2xl mx-auto" data-id="element-427">
              Spatial design that harmonizes function,
              heritage and innovation
            </p>
          </motion.div>
        </div>
      </section>
      {/* Projects Grid */}
      <section className="py-20 px-6" data-id="element-428">
        <div className="max-w-7xl mx-auto" data-id="element-429">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-430">
            {projects.map((project, index) => <motion.div key={project.title} initial={{
            opacity: 0,
            y: 50
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: index * 0.1
          }} whileHover={{
            y: -10
          }} className="group cursor-pointer" data-id="element-431">
                {project.link ? <Link to={project.link} data-id="element-432">
                    <div className="relative overflow-hidden rounded-2xl mb-6 aspect-[4/3]" data-id="element-433">
                      <motion.img src={project.image} alt={project.title} className="w-full h-full object-cover" whileHover={{
                  scale: 1.05
                }} transition={{
                  duration: 0.6
                }} data-id="element-434" />
                      <div className={`absolute inset-0 bg-gradient-to-br ${project.color} opacity-0 group-hover:opacity-40 transition-opacity duration-500`} data-id="element-435" />
                    </div>
                    <div className="space-y-2" data-id="element-436">
                      <p className="text-sm text-emerald-700 font-light tracking-wide uppercase" data-id="element-437">
                        {project.category}
                      </p>
                      <h3 className="text-2xl font-light text-stone-900 group-hover:text-emerald-800 transition-colors" data-id="element-438">
                        {project.title}
                      </h3>
                      <p className="text-stone-600 font-light leading-relaxed" data-id="element-439">
                        {project.description}
                      </p>
                    </div>
                  </Link> : <>
                    <div className="relative overflow-hidden rounded-2xl mb-6 aspect-[4/3]" data-id="element-440">
                      <motion.img src={project.image} alt={project.title} className="w-full h-full object-cover" whileHover={{
                  scale: 1.05
                }} transition={{
                  duration: 0.6
                }} data-id="element-441" />
                      <div className={`absolute inset-0 bg-gradient-to-br ${project.color} opacity-0 group-hover:opacity-40 transition-opacity duration-500`} data-id="element-442" />
                    </div>
                    <div className="space-y-2" data-id="element-443">
                      <p className="text-sm text-emerald-700 font-light tracking-wide uppercase" data-id="element-444">
                        {project.category}
                      </p>
                      <h3 className="text-2xl font-light text-stone-900" data-id="element-445">
                        {project.title}
                      </h3>
                      <p className="text-stone-600 font-light leading-relaxed" data-id="element-446">
                        {project.description}
                      </p>
                    </div>
                  </>}
              </motion.div>)}
          </div>
        </div>
      </section>
      {/* CTA Section */}
      <section className="py-20 px-6 bg-gradient-to-t from-emerald-50/40 via-stone-50 to-stone-50 border-t border-emerald-600/30" data-id="element-447">
        <div className="max-w-4xl mx-auto text-center" data-id="element-448">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} data-id="element-449">
            <h2 className="text-4xl md:text-5xl font-light mb-6 text-stone-900" data-id="element-450">
              Interested in collaborating?
            </h2>
            <p className="text-xl text-stone-600 font-light mb-8" data-id="element-451">
              Let's create something meaningful together
            </p>
            <motion.a href="mailto:rassvet.hub@gmail.com" whileHover={{
            y: -3
          }} className="group inline-block relative" data-id="element-452">
              {/* Outer border layer */}
              <div className="absolute inset-0 border-2 border-emerald-600 pointer-events-none" style={{
              clipPath: 'polygon(5% 0%, 100% 0%, 95% 100%, 0% 100%)'
            }} data-id="element-453" />
              {/* Inner filled layer */}
              <div className="relative px-6 py-2 bg-emerald-600 text-white overflow-hidden mx-3 my-1.5" style={{
              clipPath: 'polygon(8% 0%, 100% 0%, 92% 100%, 0% 100%)'
            }} data-id="element-454">
                <div className="absolute inset-0 bg-emerald-700 translate-y-[100%] group-hover:translate-y-0 transition-transform duration-300" data-id="element-455" />
                <span className="text-lg font-light relative z-10" data-id="element-456">
                  Get in Touch
                </span>
              </div>
            </motion.a>
          </motion.div>
        </div>
      </section>
    </div>;
}